import appPromotion from "../../views/appSettings/promotion.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("promotion", {
    url: "promotion/:id",
    parent: "app",
    views: {
      view: {
        template: appPromotion,
      },
    },
    reloadOnSearch: false,
    data: { title: "Promotion" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/promotion/promotion.urls.js